import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import $ from 'jquery';

import UpdateModal from '../Modals/UpdateModal';
import IziToast from '../IziToast';
import TextInput from '../TextInput';
import Select from '../Select';

const UpdateCharges = ({ requestConfig, reLoadTable, selectedCharge }) => {
  // state
  const [chargeName, setChargeName] = useState('');
  const [chargeCode, setChargeCode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [description, setDescription] = useState('');
  const [particular, setParticular] = useState('');

  // copying state from props is anti-pattern but in our case we're not relying on props update
  useEffect(() => {
    if (selectedCharge) {
      setChargeName(selectedCharge.name);
      setChargeCode(selectedCharge.code);
      setDescription(selectedCharge.description);
      setParticular(selectedCharge.particular || '');
    }
  }, [selectedCharge]);

  const updateCharges = () => {
    setIsSubmitting(true);
    let isValid = false;
    let message;
    if (chargeName && chargeCode && description) {
      isValid = true;
    } else {
      isValid = false;
      message = 'Enter the red marked fields';
      IziToast(message);
    }
    if (parseFloat(chargeCode) <= 0) {
      message = 'Enter valid charge code';
      IziToast(message);
      isValid = false;
    } else {
      isValid = true;
    }
    if (isValid) {
      const chargesObject = {
        id: selectedCharge.id,
        name: chargeName,
        code: chargeCode,
        description,
        particular,
      };
      IziToast('Updating...');
      axios
        .put(
          `${process.env.REACT_APP_API_URL}paymentcodes`,
          chargesObject,
          requestConfig,
        )
        .then(() => {
          // api doesn't give us status code or useful messages
          // if (response.data.code === 200) {
          IziToast('Charge successfully updated');
          $('#chargesModal').modal('hide');
          // }
          // setIsLoading(!isLoading);
          if (reLoadTable) reLoadTable();
        })
        .catch((error) => {
          if (error) {
            if (error.response) {
              if (error.response.data) {
                IziToast(error.response.data.error);
              }
            }
          } else {
            IziToast('An error occurred');
          }
        });
    }
  };

  return (
    <UpdateModal
      modalId="chargesModal"
      onClick={updateCharges}
      header="Update charges"
    >
      <div className="row">
        <TextInput
          type="text"
          placeholder="Enter charge name"
          caption="Charge Name"
          onChange={(event) => {
            setChargeName(event.target.value);
          }}
          value={chargeName}
          columnWidth={10}
          className={isSubmitting && !chargeName ? 'error' : ''}
        />
        <TextInput
          type="text"
          placeholder="Enter charge code"
          caption="Charge Code"
          onChange={(e) => {
            const value = /^[0-9\b]+$/;
            // allows number only
            if (e.target.value === '' || value.test(e.target.value)) {
              setChargeCode(e.target.value);
            }
          }}
          value={chargeCode}
          columnWidth={4}
          className={
            (isSubmitting && !chargeCode) || parseFloat(chargeCode) <= 0
              ? 'error'
              : ''
          }
        />
      </div>
      <div className="row">
        <TextInput
          type="text"
          placeholder="Enter charge description"
          caption="Charge Description"
          onChange={(e) => {
            setDescription(e.target.value);
          }}
          value={description}
          columnWidth={12}
          className={isSubmitting && !description ? 'error' : ''}
        />
      </div>
      <div className="row">
        <Select
          caption="Particular (optional)"
          value={particular}
          onChange={(event) => {
            setParticular(event.target.value);
          }}
          columnWidth={6}
        >
          <option value="">Not specified</option>
          <option value="rent">Rent</option>
          <option value="water">Water</option>
          <option value="service_charge">Service Charge</option>
        </Select>
      </div>
    </UpdateModal>
  );
};

UpdateCharges.propTypes = {
  requestConfig: PropTypes.objectOf(PropTypes.object),
  selectedCharge: PropTypes.oneOfType([PropTypes.object]),
  reLoadTable: PropTypes.func.isRequired,
};

UpdateCharges.defaultProps = {
  requestConfig: {},
  selectedCharge: {},
};

export default UpdateCharges;
